module.exports = __webpack_public_path__ + "static/media/postcard-review-2.d8203b08.png";